
import { Component, Vue } from 'vue-property-decorator';
import { KycRequests } from '@/api';
import { OptionalDocs } from '@/api/auth';
import ApiCancelError from '@/resources/error/ApiCancelError';
import ApiModalError from '@/resources/error/ApiModalError';
import CameraPageHeader from '@/components/CameraPageHeader.vue';
import TopContentTitle from '@/components/TopContentTitle.vue';
import TopContentText from '@/components/TopContentText.vue';
import TopContentSelectOpDoc from '@/components/TopContentSelectOpDoc.vue';
import GuideGpdocIntroduction from '@/components/GuideGpdocIntroduction.vue';
import FooterButton from '@/components/FooterButton.vue';
import ScrollToBottomButton from '@/components/ScrollToBottomButton.vue';

@Component({
  components: {
    CameraPageHeader,
    TopContentTitle,
    TopContentText,
    TopContentSelectOpDoc,
    GuideGpdocIntroduction,
    FooterButton,
    ScrollToBottomButton
  }
})
export default class Page extends Vue {
  private scrollerHeight: number = 0;
  private opDocTypeId: string[] = [];
  private isLoading: boolean = false;

  private get term(): number {
    return this.$store.getters['camera/opdocTermCurr'];
  }

  private get isScroll(): boolean {
    return this.scrollerHeight > this.$store.state.camera.displayHeight;
  }

  private get selectOpDocList(): {
    key: string;
    seqNo: number;
    page: number;
    text1: string;
    text2: string;
    text3: string;
  }[][] {
    const locale: string = this.$store.getters['i18n/locale'];
    let optionalDocs: OptionalDocs[] = this.$store.getters['auth/optionalDocs'];
    optionalDocs = Array.from(optionalDocs).sort((a, b): number => a.seqNo - b.seqNo);
    return optionalDocs.map((valueOuter) => {
      const sorted = Array.from(valueOuter.selection).sort((a, b): number => a.displayPriority - b.displayPriority);
      return sorted.map((valueInner) => ({
        key: valueInner.optionalDocType,
        seqNo: valueOuter.seqNo,
        page: valueInner.maxPages,
        text1: valueInner.optionalDocName[locale],
        text2: this.$t('202309_362', { _枚数: valueInner.maxPages }) as string,
        text3: valueInner.description[locale]
      }));
    });
  }

  private get introductionList(): {
    key: string;
    seqNo: number;
    page: number;
    text1: string;
    text2: string;
    text3: string;
  }[][] {
    return [this.selectOpDocList[this.term - 1]];
  }

  private get introductionModel(): string[] {
    return [this.opDocTypeId[this.term - 1]];
  }

  public get scrollTarget() {
    return document.querySelector('.camera-introduction');
  }

  private set introductionModel(value: string[]) {
    this.opDocTypeId.splice(this.term - 1, 1, value[0]);
  }

  public created(): void {
    this.opDocTypeId = this.$store.getters['camera/opDocType'];
  }

  public mounted(): void {
    this.calcDynamicAreaHeight();
  }

  public updated(): void {
    this.calcDynamicAreaHeight();
  }

  private calcDynamicAreaHeight(): void {
    if (!this.$el) return;
    const scroller: HTMLDivElement = this.$el.getElementsByClassName('page-scroller').item(0) as HTMLDivElement;
    const scrollerRect: DOMRect = scroller.getBoundingClientRect() as DOMRect;
    this.scrollerHeight = scrollerRect.height;
  }

  private async onStart(): Promise<void> {
    try {
      this.isLoading = true;

      const opDocType: string = this.opDocTypeId[this.term - 1];
      const opDocData = this.selectOpDocList[this.term - 1].find((data) => data.key === opDocType);
      const opDocSeqNo: number = opDocData?.seqNo || -1;
      const opDocPage: number = opDocData?.page || -1;

      const kycRequestId: number = this.$store.getters['auth/kycRequestID'];
      await KycRequests.fetchOpDocTypes(kycRequestId, { seqNo: opDocSeqNo, optionalDocType: opDocType });

      this.$store.commit('camera/setOpDocType', this.opDocTypeId);
      this.$store.commit('camera/setOpDocPageLast', opDocPage);
      this.$emit('onStart');
    } catch (error) {
      if (error instanceof ApiCancelError) {
        // キャンセルは握りつぶす
      } else if (error instanceof ApiModalError) {
        // clientRetryableで処理したエラーは握りつぶす
      } else throw error;
    } finally {
      this.isLoading = false;
    }
  }
}
